import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import EventDataTable from "../EventDataTable";

export default function TableDataWithTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div style={{ "margin-top": "10px" }}>
      <Box sx={{ maxWidth: { xs: 320, sm: 480 }, bgcolor: "background.paper" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="Inventory Data for given time"
          style={{ width: "265px" }}
        >
          <Tab label="12/22/2022 2:22PM" />
          <Tab label="12/22/2022 4:30PM" />
          <Tab label="12/22/2022 11:50PM" />
          <Tab label="12/23/2022 6:30AM" />
          <Tab label="12/23/2022 9:30AM" />
          <Tab label="12/23/2022 2:30PM" />
          <Tab label="12/23/2022 6:30PM" />
        </Tabs>
      </Box>
      <div style={{ "margin-top": "5px" }}>
        <EventDataTable />
      </div>
    </div>
  );
}
